import { AddIcon } from '@components/UI-Components/svg'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Popover from '@material-ui/core/Popover'
import Typography from '@material-ui/core/Typography'
import classNames from 'classnames'
import { useObserver } from 'mobx-react-lite'
import React from 'react'

import * as css from './ClientExclusionPopOver.css'

interface IProps {
  anchorEl?: any
  onClose?: () => void
  onAddClick?: any
  isDisabled: boolean
  channels?: any
}

export const AddChannelPopOver: React.FunctionComponent<IProps> = ({
  anchorEl,
  onClose,
  onAddClick,
  isDisabled,
  channels
}) => {
  return useObserver(function useHook() {
    const open = Boolean(anchorEl)
    const id = open ? 'add-channel-popover' : undefined

    return (
      channels?.length > 0 && (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          <div className={css.root}>
            {!isDisabled &&
              channels?.map(channel => {
                return (
                  <ListItem
                    key={id}
                    disableGutters
                    onClick={() => onAddClick(channel?.value)}
                    classes={{ root: classNames(css.listItem, css.pointer) }}
                  >
                    <ListItemText
                      className={css.listItemText}
                      primary={
                        <Typography
                          className={classNames(css.boldText, css.listItemText)}
                        >
                          {channel?.name}
                        </Typography>
                      }
                    />
                    <ListItemIcon className={css.listItemIcon}>
                      <img src={AddIcon} alt='' />
                    </ListItemIcon>
                  </ListItem>
                )
              })}
          </div>
        </Popover>
      )
    )
  })
}
